import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";
export default function BrakeMatrix({
  cars = [],
  categoryLabel = "Freio",
  groups = [],
  baseItems = [],
  extraItemsByCar = {}
}) {
  return (
    <div style={styles.brakeWrapper}>
      <table style={styles.pantographTable}>

        <thead>
          <tr>
            <th style={{ width: "40px" }}></th>
            <th style={{ width: "180px" }}></th>


          </tr>
        </thead>

        <tbody>
          <tr>

            {/* CATEGORIA */}
            <td style={styles.brakeVertical}>
              {categoryLabel}
            </td>

            {/* LABELS */}
            <td style={styles.brakeLabelsColumn}>
              {groups.map((group, i) => (
                <div key={i} style={styles.brakeGroup}>
                  <div style={styles.brakeGroupTitle}>
                    {group.title}
                  </div>
                </div>
              ))}
            </td>

            {/* CARROS */}
            {cars.map(car => {
              const extraItems = extraItemsByCar[car] || [];

              return (
                <td key={car} style={styles.brakeCell}>
                  <div style={styles.brakeStack}>

                    {/* BASE */}
                    {baseItems.map((item, i) => (

                      <div
                        key={i}

                        style={{
                          ...styles.brakeBox,

                          background:
                            item.active
                              ? (
                                getCategoryColor(
                                  item.category
                                ) || "#ef4444"
                              )
                              : styles.brakeBox.background,

                          color:
                            item.active
                              ? "#ffffff"
                              : "#111827"
                        }}
                      >
                        {item.label}
                      </div>

                    ))}

                    {/* EXTRA */}
                    {extraItems.map((item, i) => (

                      <div
                        key={`extra-${i}`}

                        style={{
                          ...styles.brakeBox,

                          background:
                            item.active
                              ? (
                                getCategoryColor(
                                  item.category
                                ) || "#ef4444"
                              )
                              : styles.brakeBox.background,

                          color:
                            item.active
                              ? "#ffffff"
                              : "#111827"
                        }}
                      >
                        {item.isNumeric ? item.value : item.label}
                      </div>

                    ))}

                  </div>
                </td>
              );
            })}

          </tr>
        </tbody>

      </table>
    </div>
  );
}